import utils from '@/mixins/utils'
const { syncTimeout } = utils.methods
const RETRIES = 30
const state = {
    items: [],
    limit: 99,
    limitReached: false,
    pendingExports: {},
    retries: RETRIES,
    loading: false
}

const mutations = {
    SET_EXPORTS (state, data) {
        state.items = data._embedded.export
        state.limit = data.export_limit
    },
    START_EXPORT (state, data) {
        state.pendingExports[data.url] = data
    },
    DECREMENT_RETRIES (state) {
        state.retries--
    },
    RESET_RETRIES (state) {
        state.retries = RETRIES
    },
    SET_LOADING (state, bul) {
        state.loading = bul
    },
    SET_LIMIT_REACH(state, value) {
        state.limitReached = value
    }
}

const actions = {
    fetchAll ({ dispatch, commit }) {
        commit('SET_LOADING', true)
		dispatch('callApi', {
			method: 'GET',
			ingoreBaseUrl: true,
			url: this._vm.CMS_BASE_URL + '/cms/export'
		}, { root: true }).then((resp) => {
            commit('SET_LOADING', false)
            commit('SET_EXPORTS', resp.data)
            commit('SET_LIMIT_REACH', resp.data.export_limit === resp.data._embedded.export.length)
		}).catch((err) => {
            console.error(err)
            this.commit('Toast/_addError', err.response.data.Message)
        })
    },
    async checkExportStatus ({ dispatch, state, commit }, id) {
        return dispatch('callApi', {
            method: 'GET',
            ingoreBaseUrl: true,
            url: this._vm.CMS_BASE_URL + '/cms/export?filter[0][name]=Id&filter[0][term]=' + id
        }, { root: true }).then(async (resp) => {
            if (resp.data._embedded.export[0].Status !== '1' && state.retries >= 0) {
                commit('DECREMENT_RETRIES')
                await syncTimeout(500)
                await dispatch('checkExportStatus', id)
            } else {
                commit('RESET_RETRIES')
                // this might be blocked in browser
                window.open(this._vm.CMS_BASE_URL + '/cms/export/' + id, '_blank')
                await dispatch('fetchAll')
            }
        }).catch((err) => {
            console.error(err)
            this.commit('Toast/_addError', err.response.data.Message)
        })
    },
    async export ({dispatch, commit}, data) {
        const url = this._vm.CMS_BASE_URL + '/cms/export'
        commit('START_EXPORT', { url })
        commit('SET_LOADING', true)
        // validate data name for export to contain only supported chars
        const reg = /^[A-Za-z0-9]+$/;
        data.Name = data.Name.split('').filter(c => reg.test(c)).join('')

        return dispatch('callApi', {
			method: 'POST',
			ingoreBaseUrl: true,
            url,
            data
		}, { root: true }).then(async (resp) => {
            commit('START_EXPORT', { url, ...resp.data })
            await dispatch('checkExportStatus', resp.data.Id)
			// commit('SET_EXPORTS', resp.data)
		}).catch((err) => {
            console.error(err)
            let errTxt = 'Failed export'
            if (err.response.data.detail.toLowerCase().includes('duplicate')) {
                errTxt += '. The name was already used!'
            }
            this.commit('Toast/_addError', errTxt)
            commit('SET_LOADING', false)
            commit('RESET_RETRIES')
        })
    },
    async delete ({dispatch, commit}, options) {
        const { id, silent } = options
        commit('SET_LOADING', true)
        return dispatch('callApi', {
            method: 'DELETE',
            ingoreBaseUrl: true,
            url: this._vm.CMS_BASE_URL + '/cms/export/' + id
        }, { root: true }).then((resp) => {
            dispatch('fetchAll')
            if (typeof silent !== undefined && !silent) {
                this.commit('Toast/_add', 'Deleted successfully')
            }
        }).catch((err) => {
            console.error(err)
            commit('SET_LOADING', false)
            // commit('Toast/_addError', 'Cannot delete at the moment. Please try again later')
            this.commit('Toast/_addError', err.response.data.Message)
        })        
    }
}

const getters = {
    items: state => state.items,
    loading: state => state.loading
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}